import { UserManager, Log } from 'oidc-client-ts';
import { AUTH_CONFIG } from '../config/auth';

// Enable logging for debugging
Log.setLogger(console);
Log.setLevel(Log.DEBUG);

class AuthService {
  constructor() {
    this.userManager = new UserManager({
      ...AUTH_CONFIG,
    });
  }

  async getUser() {
    try {
      const user = await this.userManager.getUser();
      return user;
    } catch (error) {
      console.error('Error getting user:', error);
      return null;
    }
  }

  async login() {
    try {
      // Clear any existing state before login
      await this.userManager.clearStaleState();
      await this.userManager.signinRedirect();
    } catch (error) {
      console.error('Error during login:', error);
      throw error;
    }
  }

  async logout() {
    try {
      await this.userManager.signoutRedirect();
    } catch (error) {
      console.error('Error during logout:', error);
      throw error;
    }
  }

  async handleCallback() {
    try {
      const user = await this.userManager.signinRedirectCallback();
      if (!user) {
        throw new Error('No user data received');
      }
      return user;
    } catch (error) {
      console.error('Error handling callback:', error);
      // Clear any stale state
      await this.userManager.clearStaleState();
      throw error;
    }
  }

  async getAccessToken() {
    try {
      const user = await this.userManager.getUser();
      return user?.access_token;
    } catch (error) {
      console.error('Error getting access token:', error);
      return null;
    }
  }
}

export const authService = new AuthService();
